import i18next from 'i18next';
import { all, take, call, put, takeEvery } from 'redux-saga/effects';
import { request } from '../../../xhr';
import { actions as modalActions } from '../../../Modals';
import { ModalType } from '../../../Modals/redux/types';
import { reduxModuleLoaded, createTipJarTier } from './actions';
function* handleCreateTipJarTier() {
    const data = {
        title: i18next.t('tierPopup.tipJar.title'),
        description: i18next.t('tierPopup.tipJar.description'),
        price: 2,
        display_num_subscribers: false,
        benefits: [
            i18next.t('tierPopup.tipJar.firstBenefit'),
            i18next.t('tierPopup.tipJar.secondBenefit')
        ],
        tags: [
            'tipjar',
            'tip'
        ],
        access_settings: 'all',
        thank_message_title: i18next.t('tierPopup.tipJar.thanks.title'),
        thank_message_body: i18next.t('tierPopup.tipJar.thanks.body'),
        cover_image_deviation_id: 902857689,
        is_mature: false
    };
    const response = yield call(request, {
        method: 'post',
        url: '/tier/create',
        data
    });
    yield put(modalActions.pushModal(ModalType.TIER_EDIT, {
        wrapInModal: false,
        params: response
    }));
}
export default function* userTiersSaga() {
    yield take(reduxModuleLoaded);
    yield all([
        takeEvery(createTipJarTier, handleCreateTipJarTier)
    ]);
}
